<template>
  <div class="logic">
    <el-dialog
      class="logic-dialog"
      title="筛选条件"
      :visible.sync="logicPanelData.dialogVisible"
      :close-on-click-modal="false"
      @open="open()"
      center
      width="930px"
      append-to-body>
      <div class="content">
        <el-form :model="model" :rules="rules" ref="form">
          <el-table
            ref="multipleTable"
            :data="model.filters"
            style="width: 100%"
            align="center"
            class="table"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="20px"
              ></el-table-column>
            <el-table-column
              prop="date"
              label="筛选字段"
              align="center"
              :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item v-if="logicPanelData.dialogVisible" :prop="'filters.' + scope.$index + '.columnId'" :rules='rules.columnId'>
                  <public-combobox v-model="scope.row.columnId" :options="getReportColumns"></public-combobox>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="比较类型"
              header-align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'filters.' + scope.$index + '.type'" :rules='rules.columnId'>
                  <el-select clearable v-model="scope.row.type" placeholder="请选择">
                    <el-option label="等于" value="EqualsTo"></el-option>
                    <el-option label="不等于" value="NotEqualsTo"></el-option>
                    <el-option label="大于" value="GreaterThan"></el-option>
                    <el-option label="大于等于" value="GreaterThanEquals"></el-option>
                    <el-option label="小于" value="MinorThan"></el-option>
                    <el-option label="小于等于" value="MinorThanEquals"></el-option>
                    <el-option label="包含" value="LikeExpression"></el-option>
                    <el-option label="空" value="IsNull"></el-option>
                    <el-option label="非空" value="IsNotNull"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="比较内容"
              align="center">
              <template slot-scope="scope">
                <el-form-item>
                 <el-input v-model="scope.row.defaultValue" placeholder="请输入内容"  v-on:dblclick.native="dblclick(scope.$index)" disabled></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              label="操作"
              align="center"
              width="100px">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button type="primary" @click="addFilter(scope.$index)">+</el-button>
                  <el-button type="primary" @click="delFilter(scope.$index)">-</el-button>
                </el-button-group>
              </template>
            </el-table-column>
            <!--画线-->
            <template v-for="(group, index) in getGroups" >
              <el-table-column
                width="15px"
                class-name="group"
                :key="index"
                row-style="{height: 50px}">
                <template slot-scope="scope">
                  <div
                    class="group"
                    :class="{'group-style-top': groupStyleTop(scope.$index, group),
                    'group-style-all': groupStyleAll(scope.$index, group),
                    'group-style-bottom': groupStyleBottom(scope.$index, group)}">
                    <div class="top-div"></div>
                    <div class="bottom-div" @click="delGroup(scope.$index, group)"></div>
                  </div>
                </template>
              </el-table-column>
            </template>
            <el-table-column
              class-name="address"
              prop="address"
              label="关系"
              align="center"
              width="60px">
              <template slot-scope="scope">
                <el-button type="primary" v-show="scope.$index != (model.filters.length-1)" @click="changeOperation(scope.$index)">{{scope.row.operation==='|'?'或':'且'}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span v-if="logicPanelData.dialogVisible" slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="saveExpression()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash'
import Vue from 'vue'
import Filter from '@/store/report/filter'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'logic-panel',
  props: ['logicPanelData'],
  components: {publicCombobox},
  data () {
    return {
      rules: {
        columnId: [{ required: true, message: '请选择字段', trigger: 'change' }],
        type: [{ required: true, message: '请选择比较类型', trigger: 'change' }],
        defaultValue: [{ required: true, message: '请输入比较值', trigger: 'blur' }]
      },
      model: {filters: []},
      groups: [],
      checkbox: [],
      operationFilter: {'type': '', 'index': ''}
    }
  },
  watch: {
    'model.filters' () {
      this.model.filters.forEach((filter, index) => {
        filter.index = index
        filter.operationText = filter.operation === '&' ? '且' : '或'
      })
      if (this.operationFilter.index !== '') {
        let type = this.operationFilter.type
        this.groups.forEach(filter => {
          let index = filter.indexOf(this.operationFilter.index)
          if (index >= 0) {
            // 如果删除或则增加的元素在分组内部
            if (type === 'add') {
              // 如果是增加, 判断增加的位置是不是组内的最后一个元素, 如果不是, 将当前元素增加到组内
              if (index !== filter.length - 1) {
                filter.push(filter[filter.length - 1] + 1)
              }
            } else {
              // 如果是删除, 则删除组内元素
              filter.pop()
            }
          }
        })
        this.operationFilter.type = ''
        this.operationFilter.index = ''
      }
    },
    'groups' (val) {
      // 每次操作分组的时候,删除分组中重复的元素以及长度为 1 的元素
      let groupsStr = []
      let removerIndex = []
      val.forEach((m, index) => {
        let groupStr = m.join(',')
        if (m.length === 1) {
          removerIndex.push(index)
        } else if (groupsStr.indexOf(groupStr) >= 0) {
          removerIndex.push(index)
        } else {
          groupsStr.push(groupStr)
        }
      })
      _.remove(val, (m, index) => {
        return (removerIndex.indexOf(index) >= 0)
      })
    },
    logicPanelData: {
      handler (val) {
        this.getReportColumns = val.table.columns
      },
      deep: true
    }
  },
  methods: {
    open () {
      if (this.logicPanelData.dialogVisible && this.logicPanelData.dialogType !== 'runtime') {
        if (this.logicPanelData.filters.length !== 0) {
          // 处理顺序问题
          let filters = []
          this.logicPanelData.expression.match(/\$\{(.+?)\}/g).forEach(m => {
            let id = m.substring(2, m.length - 1)
            filters.push(this.logicPanelData.filters.find(n => n.filterId === id))
          })
          this.model.filters = _.cloneDeep(filters)
        } else if (this.model.filters.length === 0) {
          this.addFilter(0)
        }
        if (this.logicPanelData.expression && this.logicPanelData.expression !== '') {
          this.setGroups(this.logicPanelData.expression)
        }
      } else {
        if (this.model.filters.length === 0) {
          this.addFilter(0)
        }
      }
    },
    saveExpression () {
      let _this = this
      // 保存
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.logicPanelData.expression = _this.handlerExpression()
          _this.logicPanelData.filters = _this.model.filters
          _this.logicPanelData.dialogVisible = false
          _this.$emit('expression', _this.logicPanelData)
        }
      })
    },
    cancel () {
      this.model.filters = this.logicPanelData.filters
      this.$nextTick(() => {
        this.logicPanelData.dialogVisible = false
      })
    },
    setGroups (expression) {
      // 设置分组条件
      this.groups = []
      let filter = this.model.filters
      expression.match(/\$\{(.+?)\}/g).forEach(m => {
        let id = m.substring(2, m.length - 1)
        expression = expression.replace(m, filter.findIndex(m => { return m.filterId === id }))
      })
      this.analyzeOperation(expression)
      expression = expression.replace(/&/g, ',')
      expression = expression.replace(/\|/g, ',')
      this.analyzeGroups(expression)
    },
    analyzeGroups (expression) {
      // 解析分组
      if (expression.indexOf('(') >= 0) {
        let firstRightBrackets = expression.indexOf(')')
        let lastLeftBrackets = expression.substring(0, expression.indexOf(')')).lastIndexOf(('('))
        let number = []
        expression.substring(lastLeftBrackets + 1, firstRightBrackets).split(',').forEach(m => {
          number.push(parseInt(m))
        })
        if (number.length > 1) {
          this.groups.push(number)
        }
        expression = expression.substring(0, lastLeftBrackets) +
          expression.substring(lastLeftBrackets + 1, firstRightBrackets) +
          expression.substring(firstRightBrackets + 1, expression.length)
        this.analyzeGroups(expression)
      }
    },
    analyzeOperation (expression) {
      // 解析表达式之间的关系
      let filters = this.model.filters
      let operations = expression.match(/(&|\|)/g)
      if (operations !== null) {
        if (filters.length !== operations.length + 1) {
          throw new Error('条件数量不一致')
        }
        operations.forEach((m, index) => {
          Vue.set(filters[index], 'operation', m)
        })
        Vue.set(filters[filters.length - 1], 'operation', '&')
        Vue.set(filters[filters.length - 1], 'operationText', '且')
      } else {
        Vue.set(filters[0], 'operation', '&')
        Vue.set(filters[0], 'operationText', '且')
      }
    },
    handlerExpression () {
      if (this.model.filters.length === 0) {
        return ''
      }
      // 处理表达式, 将多个表达式之间组合成一个表达式, 用表达式
      let str = ''
      for (let i = 0; i < this.model.filters.length; i++) {
        str = str + i + ','
      }
      str = str.substring(0, str.length - 1)
      let leftBrackets = this.groups.map(m => {
        return m[0]
      })

      let rightBrackets = this.groups.map(m => {
        return m[m.length - 1]
      })
      leftBrackets.forEach(m => {
        str = str.substring(0, str.indexOf(m)) + '(,' + str.substring(str.indexOf(m), str.length)
      })
      rightBrackets.forEach(m => {
        str = str.substring(0, str.indexOf(m) + 1) + ',)' + str.substring(str.indexOf(m) + 1, str.length)
      })
      let filters = this.model.filters
      let expression = ''
      str = str.trim()
      str.split(',').forEach(m => {
        if (m === '(') {
          expression = expression + m
        } else if (m === ')') {
          expression = expression.substring(0, expression.length - 1) + ') ' + expression.substring(expression.length - 1, expression.length)
        } else {
          let filter = filters[m]
          expression = expression + ' ${' + filter.filterId + '} ' + filter.operation
        }
      })
      expression = expression.replace(/ /g, '')
      expression = expression.substring(0, expression.length - 1).trim()
      return expression
    },
    dblclick (row) {
      let formula = this.model.filters[row].defaultValue === null ? '' : this.model.filters[row].defaultValue
      // 未完, 待处理
      // 改弹窗参照 element this.$message 改造而来, 涉及 ui 方面的可直接参考 element 进行修改
      this.$Popup.calculation({
        parameter: {
          expression: formula,
          dataSource: [],
          dataSourceEnable: false,
          functionType: ['text', 'date', 'logic', 'system'],
          calculationType: 'sql'
        },
        width: '1000px'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          this.model.filters[row].defaultValue = data.value
        }
      })
    },
    addFilter (index) {
      let filter = new Filter({'operation': '&', 'operationText': '且', 'filterType': 'senior'})
      // 记录当前增加的位置, 处理分组的信息
      this.operationFilter.type = 'add'
      this.operationFilter.index = index
      this.model.filters.splice(index + 1, 0, filter)
    },
    delFilter (index) {
      // 记录当前删除的位置, 处理分组的信息
      this.operationFilter.type = 'del'
      this.operationFilter.index = index
      this.model.filters.splice(index, 1)
    },
    changeOperation (index) {
      // 修改条件间的关系
      this.model.filters[index].operation = this.model.filters[index].operation === '&' ? '|' : '&'
      this.model.filters[index].operationText = this.model.filters[index].operation === '&' ? '且' : '或'
    },
    addGroup () {
      // 增加分组
      if (this.checkbox.length === 0 || this.checkbox.length === 1) {
        return
      }
      this.checkbox = _.sortBy(this.checkbox)
      for (let i = 0; i < this.checkbox.length - 1; i++) {
        if (this.checkbox[i] + 1 !== this.checkbox[i + 1]) {
          this.$message({
            showClose: true,
            message: '组内元素必须连续.',
            type: 'error'
          })
          return
        }
      }
      for (let i = 0; i < this.groups.length; i++) {
        let left = this.checkbox.length >= this.groups[i].length ? this.groups[i] : this.checkbox
        let right = this.checkbox.length < this.groups[i].length ? this.groups[i] : this.checkbox
        let difStr = _.difference(left, right)
        if (left.join(',') === right.join(',')) {
          this.$message({
            showClose: true,
            message: '已经存在相同的关联.',
            type: 'error'
          })
          return
        }
        if (difStr.length !== 0 && difStr.length !== left.length) {
          this.$message({
            showClose: true,
            message: '组与组之间不允许交叉.',
            type: 'error'
          })
          return
        }
      }
      this.groups.push(this.checkbox)
      this.toggleSelection()
      this.checkbox = []
    },
    delGroup (index, groups) {
      // 删除分组
      let flag = this.groupStyleTop(index, groups)
      if (flag) {
        let group = groups.find(m => { return m[0] === index })
        this.groups.splice(this.groups.indexOf(group), 1)
      }
    },
    toggleSelection () {
      // 取消复选框的选中
      let rows = []
      let filters = this.model.filters
      this.checkbox.forEach(m => {
        rows.push(filters[m])
      })
      rows.forEach(row => {
        this.$refs.multipleTable.clearSelection()
      })
    },
    groupStyleTop (index, groups) {
      // 是否属于头部样式, 画图的时候使用
      let firstStr = groups.map(m => {
        return m[0]
      })
      if (firstStr.includes(index)) {
        return true
      }
    },
    groupStyleAll (index, groups) {
      // 是否属于中间样式, 画图的时候使用
      // 防止删除数组元素产出影响, 先克隆一份出来
      let cloneGroups = _.cloneDeep(groups)
      cloneGroups.map(m => {
        return m.splice(0, 1) && m.pop()
      })
      let indexStr = [].concat([].concat.apply([], cloneGroups))
      if (indexStr.includes(index)) {
        return true
      }
    },
    groupStyleBottom (index, groups) {
      // 是否属于底部样式, 画图的时候使用
      let lastStr = groups.map(m => {
        return m[m.length - 1]
      })
      if (lastStr.includes(index)) {
        return true
      }
    },
    handleSelectionChange (val) {
      this.checkbox = []
      if (val.length === 0) {
        this.checkbox = []
      } else {
        val.forEach(m => {
          this.checkbox.push(m.index)
        })
      }
    },
    renderHeader (h) {
      let _this = this
      return [
        h('i',
          {
            class: 'el-icon-share icon-group',
            on: {
              click: function () {
                _this.addGroup()
              }
            }}),
        h('i',
          {
            class: _this.getFiltersLength === 0 ? 'el-icon-plus icon-plus' : '',
            on: {
              click: function () {
                _this.addFilter(-1)
              }
            }}),
        h('label', '筛选字段')
      ]
    }
  },
  computed: {
    getGroups () {
      // 对数组重新按照组的大小进行排序, 涉及分组的问题
      // 先按照分组中, 每组的第一个元素的大小排序
      let sortGroup = _.sortBy(this.groups, (item) => { return item[0] })
      // 然后按照每组的长度进行排序
      sortGroup = _.sortBy(sortGroup, (item) => { return item.length })
      // 定义一个三维数组, 存放分组信息, 没有交叉的分组当成一组
      let sortGroupStr = [[]]
      sortGroup.forEach(m => {
        if (sortGroupStr[0].length === 0) {
          // 三维数组为空, 直接 push
          sortGroupStr[0].push(m)
        } else {
          sortGroupStr.forEach((n, index) => {
            // 将三维维数组中二维元素转化成一维数组
            let groupStr = [].concat([].concat.apply([], n))
            let difStr = _.difference(groupStr, m)
            // 判断当前的二维数组数组中是否包含有当前分组的对象, 即是否含有交叉
            if (difStr.length === groupStr.length) {
              // 如果不存在交叉, 直接将当前的分组信息 push 当前的二维组中
              sortGroupStr[index].push(m)
            } else {
              // 如果存在交叉的部分, 重新定义一个二维数组, 然后在存在三维数组中
              let tempStr = []
              tempStr.push(m)
              // 存在重叠的部分
              sortGroupStr.push(tempStr)
            }
          })
        }
      })
      return sortGroupStr
    },
    getReportColumns: {
      get () {
        if (this.logicPanelData.table.columns) {
          return this.logicPanelData.table.columns
        }
      },
      set (val) {
        this.$set(this.logicPanelData.table, 'columns', val)
      }
    },
    getFiltersLength () {
      return this.model.filters.length
    }
  }
}
</script>

<style lang="scss">
 .logic-dialog {
  .el-dialog__header{
      border-bottom: 1px solid #ddd;
    }
    .el-dialog__body{
      padding-top: 12px;
    }
    .el-dialog {
      border-radius: 10px;
      overflow: hidden;
    }
    .title{
      .row{
        text-align: center;
      }
    }
    .row {
      padding-bottom: 10px;
    }
    .button-group{
      text-align: center;
      .el-button{
        height: 32px;
      }
    }
    .checkbox{
      padding-top: 7px;
    }
    .content{
      overflow: auto;
      max-height: 450px;
      min-height: 150px;
      min-width: 620px;
    }
    .el-table-column--selection .cell{
      padding-left: 0;
      padding-right: 0;
    }
   .el-table {
     .address {
       .cell {
         text-overflow: clip;
       }
     }
   }
    .cell{
      >.el-form-item {
        margin-bottom: 0;
      }
      .icon-group{
        position: absolute;
        top: 4px;
        left: 0;
        cursor: pointer;
      }
      .icon-plus{
        position: absolute;
        top: 4px;
        left: 18px;
        cursor: pointer;
      }
    }
    .group{
      height: 100%;
      width: 100%;
      padding: 0;
      .cell{
        height: 100%;
        width: 100%;
      }
      .top-div{
        width: 100%;
        height: 50%;
      }
      .bottom-div{
        width: 100%;
        height: 50%;
      }
      .group-style-top{
        .bottom-div{
          border-top: 1px solid;
          border-right: 1px solid;
          cursor: pointer;
        }
      }
      .group-style-bottom{
        .top-div{
          border-bottom: 1px solid;
          border-right: 1px solid;
        }
      }
      .group-style-all{
        border-right: 1px solid;
      }
    }
    .table td{
      height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/logic-panel.vue